module.exports = __webpack_public_path__ + "img/promotion_5.63464867.png";